import { motion } from "framer-motion";
import { PanelDescription } from "Signups/FamilyRegistration/Shared/PanelDescription";
import ExtendedFieldsChildren from "./Settings/ExtendedFieldsChildren";
import RegistrationGroupChildren from "./Settings/RegistrationGroupChildren";
import { Stack } from "Signups/FamilyRegistration/Shared/StyledComponents";

import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import useFamilyRegistrationAdminPermissions from "Signups/FamilyRegistration/Shared/useFamilyRegistrationAdminPermissions";
import ChildrenWelcomeMessage from "./Settings/ChildrenWelcomeMessage";

import { FnrScreen } from "UI/FnrScreens";

export default function ChildrenInfoPanel() {
  const {
    state: { selectedPanel },
  } = useFamilyRegistrationContext();

  const { shouldDisableFamilyRegistrationSettings } =
    useFamilyRegistrationAdminPermissions();

  return (
    <FnrScreen
      show={selectedPanel === "children-info"}
      side={
        selectedPanel === "giving" || selectedPanel === "finishing-up"
          ? "left"
          : "right"
      }
    >
      <Stack>
        <PanelDescription disabled={shouldDisableFamilyRegistrationSettings}>
          Family Registration will ask members about children in their home,
          including their name, email address, phone number, gender and
          birthday.
        </PanelDescription>
        <ExtendedFieldsChildren
          disabled={shouldDisableFamilyRegistrationSettings}
        />

        <RegistrationGroupChildren
          disabled={shouldDisableFamilyRegistrationSettings}
        />
        <ChildrenWelcomeMessage
          disabled={shouldDisableFamilyRegistrationSettings}
        />
      </Stack>
    </FnrScreen>
  );
}
